import styled, { css } from 'styled-components'
import Grid from '@mui/material/Grid'

export const Counter = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.greySemiDark};
  `}
`

export const TaskCol = styled(Grid)<{ $hovered: boolean }>`
  ${({ theme, $hovered }) => css`
    ${$hovered &&
    css`
      border-radius: 12px;
      background: ${theme.colors.greySemiLight};
    `}
  `}
`
